import { ApplyPromotionFailCode } from '@/types/base';
import { PromotionInfoFace } from '@/types/cart';
import { Price } from '@/types/price';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface PriceRefreshDepend {
  shipTo: string;
}

interface PriceState {
  productPrice?: {
    [key: string]: Price;
  };
  promotionInfo?: PromotionInfoFace;
  promotionError?: ApplyPromotionFailCode;
  priceRefreshDepend?: PriceRefreshDepend;
  batchRemovePrice: (catalogNumbers: string[]) => void;
  addProductPrice: (price: Price, catalogNumber: string) => void;
  batchAddProductPrice: (prices: Price[]) => void;
  setPromotionInfo: (promotionInfo: PromotionInfoFace) => void;
  setPromotionError: (errorCode: ApplyPromotionFailCode) => void;
  setPriceRefreshDepend: (priceRefreshDepend: PriceRefreshDepend) => void;
  fbpSkuInfo?: {
    [key: string]: Price;
  };
  setFBPSkuInfo: (skuInfo: any) => void;
}

export const usePriceStore = create<PriceState>()(
  devtools(
    immer((set, get) => ({
      productPrice: {},
      promotionInfo: null,
      promotionError: null,
      priceRefreshDepend: {
        shipTo: '',
      },
      batchRemovePrice: (catalogNumbers: string[]) => {
        set((state) => {
          catalogNumbers.forEach((catalogNumber) => {
            delete state.productPrice[catalogNumber];
          });
        });
      },
      addProductPrice: (price, catalogNumber) => {
        set((state) => {
          state.productPrice[catalogNumber] = price;
        });
      },
      batchAddProductPrice: (prices) => {
        set((state) => {
          prices.forEach((price) => {
            state.productPrice[price.catalogNumber] = price;
          });
        });
      },
      setPromotionInfo: (promotionInfo: PromotionInfoFace) => {
        if (!promotionInfo) {
          get().batchRemovePrice(Object.keys(get().productPrice));
        }
        set((state) => {
          state.promotionInfo = promotionInfo;
        });
      },
      setPromotionError: (error) => {
        set((state) => {
          state.promotionError = error;
        });
      },
      setPriceRefreshDepend: (priceRefreshDepend) => {
        set((state) => {
          state.priceRefreshDepend = priceRefreshDepend;
        });
      },
      setFBPSkuInfo: (skuInfos) => {
        set((state) => {
          if (!state.fbpSkuInfo || skuInfos.length === 0) {
            state.fbpSkuInfo = {};
          }
          skuInfos.forEach((skuInfo) => {
            state.fbpSkuInfo[skuInfo.catalogNumber + '_' + skuInfo.canApplyPromotion] = skuInfo;
          });
        });
      },
    })),
    {
      name: 'price-store',
    }
  )
);
